import Profile from 'components/Profile/Profile';
import { FC } from 'react';

const ProfilePage: FC = () => {
	return <Profile />;
};

export default ProfilePage;
